// @flow

import React from "react";
import { localize } from "redux-i18n";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader, Col } from "@components";
import { SchemaForm } from "@components";
import { uiSchema } from "./uiSchema";
import type { RegistrationEmails } from "@modules/service/reducer/system-access/types";

type Props = {
  onDismissHandler: () => void,
  onSubmit: (form: Object) => void,
  schema: Object | null,
  uiSchema: Object | null,
  formData: RegistrationEmails,
  title: string,
  ...PropsFromLocalize,
};

export class SystemAccessRegistrationEmailsModal extends React.Component<Props> {
  constructor(props: Props) {
    super(props);
    // Class components needs constructor for accessing the SchemaForm's ref
    this.formRef = React.createRef();
  }

  submitForm = () => {
    this.formRef.current.submit();
  };

  handleSubmit = (formData: Object) => {
    this.props.onSubmit(formData);
  };

  render() {
    return (
      <Modal className="modal-normal">
        <ModalHeader
          toggle={this.props.onDismissHandler}
          className="d-flex justify-content-between"
        >
          {this.props.title}
        </ModalHeader>
        <ModalBody>
          <SchemaForm
            ref={this.formRef}
            formData={this.props.formData}
            schema={this.props.schema}
            onSubmit={this.handleSubmit}
            uiSchema={uiSchema(this.props.t)}
            externalSubmit
          />
        </ModalBody>
        <ModalFooter className="d-flex justify-content-end">
          <Button color="secondary" onClick={this.props.onDismissHandler}>
            {this.props.t("CANCEL")}
          </Button>
          <Button materialIcon="save" onClick={this.submitForm}>
            {this.props.t("SAVE")}
          </Button>
        </ModalFooter>
      </Modal>
    );
  }
}

export default localize()(SystemAccessRegistrationEmailsModal);
